export default __webpack_public_path__ + "static/media/Integration.52f80a0e.pdf";